import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "primereact/multiselect";
import { convertIsoStringToDate } from "src/utils/helpers";
import { Calendar } from "primereact/calendar";
import { getEngineerTechnician } from "src/redux/slices/assignBuildingSlice";
import moment from "moment";
import { toast } from "react-toastify";
import {
  getATECasesStatistics,
  getBuildingsStatistics,
  getContractInformationStatistics,
  getDashboardCards,
  getMaintenanceAppointmentsStatistics,
  getMaintenanceRequestsStatistics,
  setFilterData,
  resetFilterData,
} from "src/redux/slices/dashboardSlice";
import FilterActionButtons from "src/components/FilterActionButtons/FilterActionButtons";
import useResize from "src/hooks/useResize";
import ToggleFilter from "src/components/ToggleFilter/ToggleFilter";
import { onHideCalendar, onShowCalendar } from "src/utils/common";

const DashboardFilter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration", "dashboard"]);

  const creationDateFromRef = useRef<Calendar | null>(null);
  const creationDateToRef = useRef<Calendar | null>(null);

  const { isMobile } = useResize();
  const [isFilterShown, setIsFilterShown] = useState(!isMobile);

  const assignedBuildings = useSelector(
    (state: any) => state.lookup.assignedBuildings
  );
  useEffect(() => {
    // dispatch(getAssignedBuildings() as any);
    dispatch(getEngineerTechnician() as any);
  }, []);
  const engineerTechnician = useSelector(
    (state: any) => state.assignBuilding.engineerTechnicianData
  );

  const { propertyId, startDate, endDate, contractId,PRPNumber } = useSelector(
    (state: any) => state.dashboard.filterData
  );
  const handleFilter = () => {
    dispatch(getATECasesStatistics() as any).then(() => {});
    dispatch(getDashboardCards() as any).then(() => {});
    dispatch(getBuildingsStatistics() as any).then(() => {});
    dispatch(getContractInformationStatistics() as any).then(() => {});
    dispatch(getMaintenanceRequestsStatistics() as any).then(() => {});
    dispatch(getMaintenanceAppointmentsStatistics() as any).then(() => {});
  };

  const handleFormFieldChange = (e: any) => {
    let name, value;
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = e.name;
      value = e.value;
    }
    console.log(name, value);
    dispatch(setFilterData({ field: name, value }));
    if (name === "startDate" && endDate) {
      const startDateValue = moment(value);
      const endDateValue = moment(endDate);
      if (startDateValue.isAfter(endDateValue)) {
        toast.error(t("startEndDateValidation"));
        dispatch(setFilterData({ field: "endDate", value }));
      }
    }
  };

  const handleClearFilterForm = (): void => {
    dispatch(resetFilterData());
    dispatch(getEngineerTechnician() as any);
    handleFilter();
  };

  const toggleFilter = () => {
    setIsFilterShown(!isFilterShown);
  };

  return (
    <div className="d-flex flex-column">
      <ToggleFilter onClick={toggleFilter} />
      <div
        className={`pt-3 maintenance-requests-filter ${
          !isMobile || isFilterShown ? "d-flex" : "d-none"
        }`}
      >
        <p className="d-flex mt-1 me-2 ms-2 mb-2 align-items-start fit-content filter-by-label">
          {t("filterBy")}
        </p>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="filter-row mb-0">
            <MultiSelect
              filter
              resetFilterOnHide
              value={propertyId}
              onChange={handleFormFieldChange}
              options={assignedBuildings}
              optionLabel={"buildingName"}
              placeholder={t("filterByBuilding")}
              id="assignedBuildingId"
              name="propertyId"
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onHide={() => {
                dispatch(getEngineerTechnician() as any);
              }}
            />
            <MultiSelect
              filter
              resetFilterOnHide
              id="contractIds"
              options={engineerTechnician}
              placeholder={t("managerSupervision")}
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              value={contractId}
              optionValue={"contractIds"}
              optionLabel="engineerTechnicianName"
              name="contractId"
            />
            <Calendar
              value={startDate || moment().subtract(7, "days").toDate()}
              onChange={handleFormFieldChange}
              readOnlyInput
              placeholder={t("creationDateFrom")}
              name="startDate"
              dateFormat="dd/mm/yy"
              showIcon
              ref={creationDateFromRef}
              onHide={() => onHideCalendar(creationDateFromRef)}
              onShow={() => onShowCalendar(creationDateFromRef)}
              key={`startDate-${startDate?.toString()}`}
            />

            <Calendar
              value={endDate || moment().endOf("year").toDate()}
              onChange={handleFormFieldChange}
              readOnlyInput
              placeholder={t("creationDateTo")}
              name="endDate"
              dateFormat="dd/mm/yy"
              minDate={
                !startDate
                  ? new Date(-8640000000000000)
                  : convertIsoStringToDate(startDate)
              }
              ref={creationDateToRef}
              onHide={() => onHideCalendar(creationDateToRef)}
              onShow={() => onShowCalendar(creationDateToRef)}
              key={`endDate-${endDate?.toString()}`}
            />
            <input
            type="text"
            className="p-inputtext p-component p-inputtext p-component"
            name="PRPNumber"
            value={PRPNumber || ""}
            onChange={handleFormFieldChange}
            placeholder={t("PRPNumber")}
/>
            <FilterActionButtons
              handleFilter={handleFilter}
              handleClear={handleClearFilterForm}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default DashboardFilter;
